import { i18n } from '../plugins/i18n'

export const mediaLibraryCategoriesConst = [
  {
    id: 'exterior',
    name: i18n.t('labels.mediaLibraryCategories.exterior')
  },
  {
    id: 'interior',
    name: i18n.t('labels.mediaLibraryCategories.interior'),
  },
  {
    id: 'product',
    name: i18n.t('labels.mediaLibraryCategories.product'),
  },
  {
    id: 'food_and_drink',
    name: i18n.t('labels.mediaLibraryCategories.foodAndDrink'),
  },
  {
    id: 'menu',
    name: i18n.t('labels.mediaLibraryCategories.menu'),
  },
  {
    id: 'common_area',
    name: i18n.t('labels.mediaLibraryCategories.commonArea'),
  },
  {
    id: 'teams',
    name: i18n.t('labels.mediaLibraryCategories.teams'),
  },
  {
    id: 'cover',
    name: i18n.t('labels.mediaLibraryCategories.cover'),
  },
  {
    id: 'at_work',
    name: i18n.t('labels.mediaLibraryCategories.atWork'),
  },
  {
    id: 'rooms',
    name: i18n.t('labels.mediaLibraryCategories.rooms'),
  },
  {
    id: 'category_unspecified',
    name: i18n.t('labels.mediaLibraryCategories.categoryUnspecified'),
  },
  {
    id: 'additional',
    name: i18n.t('labels.mediaLibraryCategories.additional'),
  }
]
